import { nanoid } from '@reduxjs/toolkit';
import { IAlertMessage } from './interface';
import { MESSAGE_DEFAULTS } from './private';

export function constructMessage(
    message: Partial<IAlertMessage>,
    defaults?: Partial<IAlertMessage>,
): IAlertMessage {
    const newItem: Required<IAlertMessage> = {
        id: message.id ?? defaults?.id ?? nanoid(),
        show: message.show ?? defaults?.show ?? MESSAGE_DEFAULTS.show,
        title: message.title ?? defaults?.title ?? MESSAGE_DEFAULTS.title,
        textAccept: message.textAccept ?? defaults?.textAccept ?? MESSAGE_DEFAULTS.textAccept,
        textDecline: message.textDecline ?? defaults?.textDecline ?? MESSAGE_DEFAULTS.textDecline,
        onAccept: message.onAccept ?? defaults?.onAccept ?? MESSAGE_DEFAULTS.onAccept,
        onDecline: message.onDecline ?? defaults?.onDecline ?? MESSAGE_DEFAULTS.onDecline,
        options: message.options ?? defaults?.options ?? MESSAGE_DEFAULTS.options,
    };

    return newItem;
}
